import type { RoseRocketCustomer } from '../types/entities';
import { isIsoTimestamp, required } from './common';

export function validateCustomer(customer: RoseRocketCustomer): string[] {
  const errors: string[] = [];
  if (!required(customer.id)) errors.push('Missing customer id');
  if (!required(customer.name)) errors.push('Missing customer name');
  if (!isIsoTimestamp(customer.updated_at)) errors.push('Invalid updated_at timestamp');
  if (customer.email && !/^\S+@\S+\.\S+$/.test(customer.email)) errors.push('Invalid email');
  return errors;
}
